import React, { useState } from 'react'
import Footer from '../footer/Footer'
import Navbar from '../Navbar'
import materialimg from '../../assets/images/material.png';
import MaterialHook from './MaterialHook';
import arrowDown from '../../assets/images/Arrowdown.png';
import arrowUp from '../../assets/images/Arrowup.png';

const Material = () => {
    const { data,handleInnerPage } = MaterialHook()
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (sectionIndex) => {
        setActiveIndex(activeIndex === sectionIndex ? null : sectionIndex);
    };

    return (
        <div>
            <Navbar />
            <div className='pt-3 innerBg'>
                <h1 style={{ color: 'white', fontWeight: '600' }}>Material</h1>
            </div>
            <div className='py-5 my-3'>
                <div className='querycard'>
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                        <div className="row">
                            {data.length >0 ?
                            data.map((section, sectionIndex) => (
                                <div key={section.section_id} className="col-md-6 col-12">
                                    <div className="querycarddiv">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id={`flush-heading-${sectionIndex}`}>
                                                <button
                                                    className={`accordion-button text-color fw ${activeIndex === sectionIndex ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => handleToggle(sectionIndex)}
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse-${sectionIndex}`}
                                                    aria-expanded={activeIndex === sectionIndex ? 'true' : 'false'}
                                                    aria-controls={`collapse-${sectionIndex}`}
                                                >
                                                   {section.section_name}
                                                    <img
                                                        src={activeIndex === sectionIndex ? arrowUp : arrowDown}
                                                        alt="Toggle Icon"
                                                        className="accordion-icon"
                                                        style={{ width: '32px', height: '32px', marginLeft: 'auto' }}
                                                    />
                                                </button>

                                            </h2>
                                            <div
                                                id={`flush-collapse-${sectionIndex}`}
                                                className={`accordion-collapse collapse ${activeIndex === sectionIndex ? 'show' : ''}`}
                                                aria-labelledby={`flush-heading-${sectionIndex}`}
                                                data-bs-parent="#accordionFlushExample"
                                            >
                                                <div className="accordion-body">
                                                    <div className="accordion accordion-flush" id={`accordionInnerExample-${sectionIndex}`}>
                                                        {section.topics.map((topic) => (
                                                            <div key={topic.topics_id} className="accordion-item">
                                                                <div className="d-flex justify-content-between inneraccordion" style={{ cursor: "pointer" }} onClick={()=>handleInnerPage(topic.topics_id)}>
                                                                    <div className="d-flex">
                                                                        <img src={materialimg} />
                                                                        <div className="ms-5 position-relative" style={{ top: "17px" }}>
                                                                            <p className="fw basecolor" >
                                                                                {topic.topic}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <h5 className="text-color fw position-relative" style={{ top: "17px" }}>
                                                                            PDF
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        :
                        <p>No material is Available</p>}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Material
